export default {
  'onlineOrderingSettings.title': 'Online Ordering',
  'onlineOrderingSettings.tabs.general': 'General',
  'onlineOrderingSettings.tabs.display': 'Display',
  'onlineOrderingSettings.tabs.feeAndTips': 'Fee & Tips',

  'onlineOrderingSettings.section.banner': 'Banner',
  'onlineOrderingSettings.section.notice': 'Notice',
  'onlineOrderingSettings.section.layout': 'Layout',
  'onlineOrderingSettings.section.businessHour': 'Business hour',
  'onlineOrderingSettings.section.specialTime': 'Special Hours',
  'onlineOrderingSettings.section.menuHour': 'Menu hour',
  'onlineOrderingSettings.section.preparation': 'Preparation',
  'onlineOrderingSettings.section.autoConfirmOrders': 'Order Auto-Confirmation',
  'onlineOrderingSettings.section.fee': 'Fee',
  'onlineOrderingSettings.section.tips': 'Tips',

  'onlineOrderingSettings.section.preparation.prepareTime': 'Order Scheduling Interval',
  'onlineOrderingSettings.section.preparation.schedulingSettings': 'Order Scheduling Duration',
  'onlineOrderingSettings.section.notice.titleEN': 'Title',
  'onlineOrderingSettings.section.notice.contentEN': 'Content',
  'onlineOrderingSettings.section.notice.titleZH': 'Foreign Title',
  'onlineOrderingSettings.section.notice.contentZH': 'Foregin Content',
  'onlineOrderingSettings.section.layout.pc': 'PC Layout',
  'onlineOrderingSettings.section.layout.mobile': 'Mobile Layout',
  'onlineOrderingSettings.section.layout.recommend': ' (recommend)',
  'onlineOrderingSettings.section.layout.image_left': 'image-left',
  'onlineOrderingSettings.section.layout.image_right': 'image-right',
  'onlineOrderingSettings.section.layout.image_top': 'image-top',
  'onlineOrderingSettings.section.specialTime.allDaysClose': 'All days close',
  'onlineOrderingSettings.section.menuHour.guide': 'For Online Ordering’s Menu hour setting, please go to',
  'onlineOrderingSettings.section.autoConfirmOrders.guide':
    'For configuring auto-confirmation of online orders, please go',
  'onlineOrderingSettings.section.fee.guide': 'For configuring fees of online orders, please go',
  'onlineOrderingSettings.section.tips.guide': 'For Online Ordering’s Tips setting, please go',
  'onlineOrderingSettings.inputLimit': ' (Up To {maxCount} characters)',
  'onlineOrderingSettings.customTipMaxAmount': 'Customize maximum tip amount',

  'onlineOrderingSettings.action.addTime': 'Add Time',
  'onlineOrderingSettings.action.uploadBanner': 'Upload Banner',

  'onlineOrderingSettings.bannerUploadGuide':
    'The recommended uploaded image size is 1312 x 196 px, and the uploaded image format is JPG, JPEG; the size should be within 5M.',
  'onlineOrderingSettings.cropBanner': 'Crop Banner',

  'onlineOrderingSettings.low': 'Low',
  'onlineOrderingSettings.medium': 'Mid',
  'onlineOrderingSettings.high': 'High',
  'onlineOrderingSettings.default': 'Default',
  'onlineOrderingSettings.enable_dish_level_notes': 'Enable Dish Level Notes',
  'onlineOrderingSettings.options': 'Option',
};
